import { lazy } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import Layouts from "../pages/Layouts";



// import ProcessesList from '../pages/ProcessesList';
// TODO: check component name

const ProcessesList = lazy(() => import("../pages/ProcessesList"));
const ReportsList = lazy(() => import("../pages/ReportsList"));
const TasksList = lazy(() => import("../pages/TasksList"));
const Process = lazy(() => import("../pages/Process"));
const Associate = lazy(() => import("../pages/Associate"));
const MyTask = lazy(() => import("../pages/MyTask"));
const AutoTemplateListPage = lazy(() => import("../pages/Process/autoTemplate"));
const EditAutoTemplate = lazy(() => import("../pages/Process/autoTemplate/EditAutoTemplate"));
const ViewAutoTemplate = lazy(() => import("../pages/Process/autoTemplate/ViewAutoTemplate"));
const TaskManager = lazy(() => import("../pages/Process/taskManager"));
const TaskPropertyList = lazy(
  () => import("../pages/Process/taskManager/TaskPropertyList")
);
const TemplateManagerListPage = lazy(
  () => import("../pages/Process/templateManager")
);
const AddTemplateManager = lazy(
  () => import("../pages/Process/templateManager/AddTemplateManager")
);
const AddTemplateBPMN = lazy(
  () => import("../pages/Process/templateManager/AddTemplateBPMN")
);

const planTrackRouter = [
  {
    path: "/plantrack",
    element: <Layouts />,
    children: [
      {
        path: "processeslist",
        element: <ProcessesList />,
      },
      {
        path: "reportslist",
        element: <ReportsList />,
      },
      {
        path: "taskslist",
        element: <TasksList />,
      },
      {
        path: "process",
        element: <Process />,
      },
    ],
  },
  {
    path: "/process",
    element: <Layouts />,
    children: [
      {
        path: "associate",
        element: <Associate />,
      },
      {
        path: "bulk-associate",
        element: <Associate isBulk={true}/>,
      },
      {
        path: "initiate",
        element: <Process isInitiate={true}/>,
      },
      {
        path: "bulk-initiate",
        element: <Process isInitiate={true} isBulk={true}/>,
      },
      {
        path: ":processId",
        element: <Process />,
      }
    ],
  },
    {
    path: "/mytask",
    element: <Layouts />,
    children: [
      {
        path: "",
        element: <MyTask />,
      }
    ],
  },
  {
    path: "/*",
    element: <Navigate to="/plantrack/processeslist" />,
  },
  {
    path: "/bpmn",
    element: <Layouts />,
    children: [
      {
        path: "",
        element: <Navigate to="task-manager" />,
      },
      {
        path: "task-manager",
        element: <TaskManager />,
      },
      {
        path: "task-manager/properties/:taskId",
        element: <TaskPropertyList />,
      },
      {
        path: "template-manager",
        element: <TemplateManagerListPage />,
      },
      {
        path: "template-manager/edit-template-manager/:templateId",
        element: <AddTemplateManager />,
      },
      {
        path: "template-manager/add-template-manager",
        element: <AddTemplateManager />,
      },
      {
        path: "template-manager/add-template-bpmn/:templateId",
        element: <AddTemplateBPMN />,
      },
      {
        path: "template-manager/edit-template-bpmn/:templateId",
        element: <AddTemplateBPMN isEdit />,
      },
      {
        path: "auto-launcher",
        element: <AutoTemplateListPage />,
      },
      {
        path: "auto-launcher/edit/:recordId",
        element: <EditAutoTemplate />,
      },
      {
        path: "auto-launcher/view/:recordId",
        element: <ViewAutoTemplate />,
      }
    ],
  },

  // {
  //   path: "/testplantrack",
  //   element: <TestProcesses />,
  // },
];

const Router = createBrowserRouter(planTrackRouter);
export { Router };
